import { amplitude } from "@eis-poc/lib-discover-medical-mfes";

const RETURN_TO_URL_PLACEHOLDER = "##returnToUrl##";
const shouldAppendReturnToUrl = (url) => {
  return (
    typeof window !== "undefined" &&
    !window?.location?.href?.match(/returnToUrl/) &&
    !url?.match(/returnToUrl/)
  );
};

const getReturnToUrlByLocation = () => {
  return typeof window !== "undefined"
    ? encodeURIComponent(window.location.href)
    : "/";
};

const assignReturnToUrlForLinkUrls = (linkURLs) => {
  const returnToUrl = getReturnToUrlByLocation();
  if (linkURLs) {
    for (const url in linkURLs) {
      if (shouldAppendReturnToUrl(url)) {
        linkURLs[url] = linkURLs[url].replace(
          RETURN_TO_URL_PLACEHOLDER,
          returnToUrl
        );
      }
    }
  }
};

// [DE52387](https://rally1.rallydev.com/#/detail/defect/440390658528?fdp=true): Switch Location Fixes x 2
const assignReturnToUrlForSwitchLocation = (profileId) => {
  return `/customerProfiles/${profileId}?returnToUrl=/`;
};

/**
 * Handles appending amplitude device ID query param to a given url
 *
 * @param {string} url
 */
const appendAmplitudeDeviceId = (url) => {
  const deviceId = amplitude.getUserDevice();
  if (typeof window !== "undefined" && url && deviceId) {
    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}amp_device_id=${deviceId}`;
  } else {
    return url;
  }
};

export {
  appendAmplitudeDeviceId,
  assignReturnToUrlForLinkUrls,
  assignReturnToUrlForSwitchLocation,
};
